let idCounter = 0;

/**
 * Returns a unique number each time it is called.
 *
 * ```ts
 * tt.uniqueId();
 * // => 0;
 *
 * tt.uniqueId();
 * // => 1
 * ```
 */
export function uniqueId() {
  return idCounter++;
}
